<template>
  <el-dialog
    title="确认发布"
    :visible.sync="dialogVisible"
    width="80%"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose">
    <div>
      <Info
        title="课件信息"
        v-if="infoData"
        :data.sync="infoData"
        @onInput="onInput"
      />
      <!-- <TableBox
        title="课件更新记录"
        :tableHead="recordHead"
        :tableData="recordData"
        @onRowClick="onRowClick"
      /> -->
      <TableBox
        v-if="id"
        title="金币扣除"
        subTitle="涉及到公共收费素材会进行扣除金币"
        :is-order="true"
        :is-page="false"
        :tableHead="coinTableHead"
        :tableData="coinTableData"
        :total.sync="total"
      />
      <!--el-checkbox class="info" v-model="isValidate">下次不再弹出</el-checkbox-->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button @click.stop="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as ResultServer from '../../../../api/result'
import LocalStorage from '../../../../utils/localStorageUtil'
import Info from './components/info'
import TableBox from './components/tableBox'
import { recordHead } from './recordData'
import { coinTableHead } from './coinData'

const classTypeEnum = {
  'online': '线上课件',
  'offline': '线下课件',
  'double_teacher': '双师课件'
}

export default {
  name: 'detail',
  components: {
    Info,
    TableBox
  },
  props: {
    id: [Number, String],
    practiceId: [Number, String],
    isPractice: {
      type: Boolean,
      default: false
    },
    isMove: {
      type: Boolean,
      default: false
    },
    cover: String,
    visible: Boolean,
    value: [Object, String],
    defaultValue: Object,
    lessonInfo: Object
  },
  computed: {
    // 名称或标题正在被编辑
    isEditing (){
      let state = false
      try {
        this.infoData.map(v=>{
          if(v.edit) {
            state = true
          }
        })
      } catch (e) {
        console.log('名称或标题正在被编辑失败==>', e)
      }
      return state
    },
  },
  watch: {
    visible (vl) { this.dialogVisible = vl },
    dialogVisible (vl) { this.$emit('update:visible', vl) },
    cover (vl) { this.newCover = vl },
    newCover (vl) { this.$emit('update:cover', vl) },
    // value (vl) { this.form = vl },
    // 'form.value': {
    //   handler (vl) {
    //     this.$emit('update:value', vl)
    //   }
    // },
    // defaultValue: {
    //   handler (vl) {
    //     this.form.map(v => {
    //       if (v.type === 'Select') {
    //         v.value = `${vl[v.attr]}`
    //       } else if (v.type === 'UploadTencent') {
    //         const img = vl[v.attr].split(',')
    //         v.value = img && img.map(v => { return { url: v } })
    //       } else {
    //         v.value = vl[v.attr]
    //       }
    //     })
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  created () {
    this.init()
  },
  data () {
    return {
      isSending: false, // 是否正在发布
      isValidate: false, // 下次是否弹出
      oldData: null, // 记住历史数据
      recordHead,
      recordData: [],
      coinTableHead,
      coinTableData: [],
      dialogVisible: this.visible,
      infoData: null,
      total: '',
      newCover: this.cover // 课件图片
    }
  },
  methods: {
    init () {
      this.getDetail()
    },
    onInput(item){
      if(this.$utils.isFastExecute(500)) return false
      // 编辑课件信息
      console.log('编辑课件信息==>', item)
      if(item.attr){
        switch (item.attr) {
          case 'name':
            console.log(item)
            this.update({...this.oldData,name: item.value})
            break
          case 'title':
            this.update({...this.oldData,title: item.value})
            break
          case 'cover':
            this.update({...this.oldData,cover: item.value})
            break
          default:
        }
      }
    },
    // 修改名称 ｜ 标题
    async update(data){
      console.log('修改==>', data)
      let newObj = {
        method: 'post',
        id: data.id,
        clientsId: this.$store.state.initConfig.school_id,
        "category_id":this.$store.state.initConfig.category_id,
        "name":data.name,
        "title":data.title,
        "type":data.type,
        "cover":data.cover,
        course_auth_token: LocalStorage.getCourseToken()
      }
      const res = await ResultServer.updateResult(newObj)
      if(res.status_code === 200){
        this.$message.success('编辑成功')
        if(res.data.cover) this.newCover = res.data.cover
        // this.init()
        this.$emit('onUpdate', data)
      }else {
        this.$message.error('编辑失败')
      }
    },
    handleSubmit(){
      if (this.isEditing) {
        this.$message.error('课件名称或标题正在被编辑')
        return false
      }
      if (!this.isSending) {
        this.isSending = true
        // 如果勾选了不再提醒弹窗，下次发布则直接发布
        LocalStorage.setWarn(JSON.stringify({id: this.id,practice_id: this.practiceId, validate: this.isValidate}))

        this.$emit('onDetail')
        // this.handleClose()
      }
    },
    onRowClick (row) {
      console.log('选中行==>', row)
      this.getPackDetail({ id: row.id, usersId: row.users_id })
    },
    async getDetail () {
      const id = this.id
      if(!id) {
        this.infoData = [
          { attr: 'name', key: '课件名称：', value: this.lessonInfo.practiceName }
        ]
        return false
      }
      const res = await ResultServer.getResultDetail({
        id,
        clientsId: this.$store.state.initConfig.school_id
      })
      const { data } = res
      this.oldData = data
      this.infoData = [
        { attr: 'name', key: '课件名称：', value: data.name, type: 'edit' },
        // { key: '创建时间：', value: data.created_at },
        { attr: 'title', key: '课件标题：', value: data.title, type: 'edit' },
        // { key: '创建人员：', value: data.created_users.name },
        { attr: 'type', key: '课件类型：', value: classTypeEnum[this.$store.state.curClassType], type: 'select'},
        // { key: '发布时间：', value: data.attr_last.updated_at },
        // { key: '课件时间：', value: '--' },
        { attr: 'cover', key: '课件图片：', value: data.cover, type: 'image' },
        // { key: '更新状态：', value: data.package_status },
        // { key: '更新时间：', value: data.updated_at }
      ]

      if(this.isPractice){
        this.infoData[0].type = ''
        this.infoData[1].type = ''
        this.infoData[3].disabled = true
        this.infoData.push({ attr: 'practiceName', key: '练习名称：', value: this.lessonInfo.practiceName })
      }

      // 获取金币扣除列表
      // const coin = await ResultServer.getPacketPrice({id: this.$route.query.id})
      // console.log(coin)
      // debugger

      // 获取更新记录
      // const records = await ResultServer.getResultPackList({
      //   usersId: data.created_users_id,
      //   clientsId: this.$store.state.initConfig.school_id,
      //   resultId: this.id
      // })
      // this.recordData = records.items.map(v => {
      //   return {
      //     id: v.id,
      //     status: this.getStatus(v.result_attr.package_status),
      //     created_at: v.created_at,
      //     amount: v.amount,
      //     name: v.editor_user.name,
      //     mobile: v.editor_user.mobile
      //   }
      // })
      // console.log('res==>getDetail', res, records)

      // 获取打包记录详情
      // if (records.items[0] && records.items[0].id) {
      this.getPackDetail()
      // }
    },
    getStatus (type) {
      let name = ''
      switch (`${type}`) {
        case 'success':
          name = '打包成功'
          break
        case 'failure':
          name = '打包失败'
          break
        case 'run':
          name = '打包中'
          break
        case 'unpublished':
          name = '未发布'
          break
        default:
      }
      return name
    },
    // 获取打包详情
    async getPackDetail () {
      // 获取打包记录详情
      if (this.id) {
        const packDetail = await ResultServer.getPacketPrice({
          id: this.id,
          clientsId: this.$store.state.initConfig.school_id
        })

        console.log('获取打包详情==>', packDetail)
        const detail = packDetail.data.detail
        this.total = packDetail.data.total
        this.coinTableData = Object.keys(detail).map(v => {
          return {
            name: detail[v].name,
            number: detail[v].number,
            amount: detail[v].gold
          }
        })
      }
    },
    onAttr (item, index, target) {
      console.log('attr==>', item, index, target)
    },
    handleClose () {
      this.dialogVisible = false
      this.isSending = false
    },
    submit () {
      const state = this.$refs.form.validateForm()
      const obj = this.$_.cloneDeepWith((this.defaultValue))
      if (state) {
        let img = []
        this.form.map(v => {
          img = []
          if (v.type === 'Select') {
            obj[v.attr] = `${v.value}`
          } else if (v.type === 'UploadTencent') {
            if (v.value && v.value.length > 0) {
              v.value.map(v => img.push(v.url))
            }
            obj[v.attr] = img.toString()
          } else {
            obj[v.attr] = v.value
          }
        })
        console.log(obj)
        // debugger
        this.$emit('success', obj)
        this.handleClose()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info{
  margin-left: 40px;
}
</style>
